import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { SITE_CSS, PAGES } from './pages';

// Mounts one page of the Walm static site (walm-site-v2) inside the app.
// The markup, CSS and page scripts are generated by scripts/build-walm-site.py.
const THREE_SRC = 'https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js';

function loadThree() {
  if (window.THREE) return Promise.resolve();
  return new Promise((resolve, reject) => {
    const s = document.createElement('script');
    s.src = THREE_SRC; s.async = true; s.onload = resolve; s.onerror = reject;
    document.head.appendChild(s);
  });
}

export default function WalmSite({ page }) {
  const rootRef = useRef(null);
  const { hash } = useLocation();
  const data = PAGES[page];

  useEffect(() => {
    if (!data) return undefined;
    const prevTitle = document.title;
    document.title = data.title;
    const hadDark = document.body.classList.contains('dark-mode');
    document.body.classList.remove('dark-mode');
    document.documentElement.classList.add('walm-site');

    let cancelled = false;
    const run = () => {
      if (cancelled || !data.js) return;
      try { new Function(data.js)(); } catch (e) { console.error('walm page script', e); } // eslint-disable-line no-new-func
      if (hash) { const el = document.getElementById(hash.slice(1)); if (el) el.scrollIntoView(); }
    };
    (data.three ? loadThree() : Promise.resolve()).then(run, run);

    return () => {
      cancelled = true;
      document.title = prevTitle;
      document.documentElement.classList.remove('walm-site');
      if (hadDark) document.body.classList.add('dark-mode');
    };
  }, [data, hash]);

  if (!data) return null;
  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: SITE_CSS + '\n' + data.css + '\n' +
        '/* host app overrides */\nhtml.walm-site #root{background:#f3f4f8 !important}html.walm-site #root::before{display:none !important}html.walm-site body{background:#f3f4f8 !important}html.walm-site .App{text-align:left;min-height:0}' }} />
      <div ref={rootRef} dangerouslySetInnerHTML={{ __html: data.html }} />
    </>
  );
}
